import { render, staticRenderFns } from "./setMeal.vue?vue&type=template&id=f48c78de&scoped=true"
import script from "./setMeal.vue?vue&type=script&lang=js"
export * from "./setMeal.vue?vue&type=script&lang=js"
import style0 from "./setMeal.vue?vue&type=style&index=0&id=f48c78de&prod&lang=css"
import style1 from "./setMeal.vue?vue&type=style&index=1&id=f48c78de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48c78de",
  null
  
)

export default component.exports